// extracted by mini-css-extract-plugin
export default {"scrollFooter":"ScrollFooter_scrollFooter__RqiRB","visible":"ScrollFooter_visible__xddcX"};